import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { API_URL } from '../../utils/api';
import { fetchAvatarsBulk } from '../../utils/avatars';
import { flairNameProps } from '../../utils/flair';
import FlairEmblem from '../shop/FlairEmblem';
import { getRankTier } from './constants';
import RankShield from './RankShield';
import './Elo.css';
import SteamAvatar from '../common/SteamAvatar';
import CountryFlag from '../common/CountryFlag';

const EloLeaderboardCard = ({ onSelectPlayer }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/elo/leaderboard`)
      .then(res => res.json())
      .then(async (eloData) => {
        const list = Array.isArray(eloData) ? eloData.slice(0, 5) : [];
        const steamids = list.map(p => p.steamid64).filter(Boolean);
        await fetchAvatarsBulk(steamids);
        setData(list);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="leaderboard-card">
      <div className="leaderboard-header">
        <span className="leaderboard-icon">🏅</span>
        <h3>{t('elo.ratingTitle')} <span style={{ fontSize: '0.6em', color: 'var(--text-muted)', fontWeight: 400 }}>(5v5)</span></h3>
      </div>
      {loading ? (
        <div className="loading-skeleton">
          {[...Array(5)].map((_, i) => <div key={i} className="skeleton-row" />)}
        </div>
      ) : (
        <div className="leaderboard-list">
          {data.map((entry, index) => {
            const tier = getRankTier(entry.elo);
            return (
              <div
                key={entry.steamid64 || index}
                className={`leaderboard-row clickable ${index === 0 ? 'top-player' : ''}`}
                onClick={() => onSelectPlayer && entry.steamid64 && onSelectPlayer(entry.steamid64)}
              >
                <span className={`rank rank-${index + 1}`}>{index + 1}</span>
                {entry.steamid64 && <SteamAvatar steamid64={entry.steamid64} name={entry.player_name} size="small" />}
                <span className="leaderboard-identity">
                  <span {...flairNameProps(entry.flair_name_color)}>
                    {entry.country && <CountryFlag code={entry.country} size="sm" className="leaderboard-flag" />}
                    {entry.player_name}
                    {entry.flair_badge && ` ${entry.flair_badge}`}
                    {entry.current_streak >= 3 && ' 🔥'}
                    {entry.current_streak <= -3 && ' ❄️'}
                  </span>
                  <FlairEmblem emblem={entry.flair_emblem} />
                </span>
                <span className="player-stat" style={{ color: tier.color, display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
                  <RankShield tier={tier} size={18} /> {entry.elo}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default EloLeaderboardCard;
